import type { ThreadAssistantMessagePart } from "@assistant-ui/react";

/** Constant tool name that routes a genui part to the GenUIComponentRegistry renderer. */
export const GENUI_TOOL_NAME = "genui";

/** The assistant-ui part shape a display GenUI component is rendered as. */
export type GenUIToolCallPart = Extract<ThreadAssistantMessagePart, { type: "tool-call" }>;

/**
 * Args of a genui tool-call part. assistant-ui wants a `ReadonlyJSONObject` here but does not
 * export the type, so we name it structurally to cast the wire props once at the boundary.
 */
type ToolCallArgs = GenUIToolCallPart["args"];

export interface GenUIComponentPayload {
  /** Stable component instance id (the tool_call_id). */
  componentId: string;
  /** Component name the registry dispatches on (e.g. `render_patient_card`). */
  component: string;
  props?: Record<string, unknown>;
  schemaVersion?: string;
}

/**
 * Build the message part that renders a display GenUI component.
 *
 * Shared by the two paths a component can reach the UI on — the live stream
 * (`transport.ts`) and history replay (`history.ts`) — so a card looks the same
 * during the turn that produced it and after a reload.
 */
export function genuiToolCallPart({
  componentId,
  component,
  props,
  schemaVersion,
}: GenUIComponentPayload): GenUIToolCallPart {
  return {
    type: "tool-call",
    toolCallId: componentId,
    toolName: GENUI_TOOL_NAME,
    args: {
      component,
      props,
      componentId,
      schemaVersion,
    } as ToolCallArgs,
    argsText: JSON.stringify(props ?? {}),
  };
}
